import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const mfsOpal = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "MFS Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "MFS Werkstatt-Buchung",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu mobilize-fs.de",
        navbar: {
          partnerLogo: {
            alt: "MFS",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/mfs-opal",
    },
  },
};
